import { useState } from 'react';

import { Gate } from '../../../global/contexts/auth/auth';
import { IconFarm } from '../../../common/icons';
import { formatDateOnly } from '../../../common/utils/date';
import { useFarmMoves } from '../contexts/farm-moves';
import TransferFarmForm from '../forms/transfer-farm';

import '../../../common/styles/catalog.css';

// Ubicación de la vaca (admin-animals.md · 0036): finca actual + bitácora de traslados, con
// acción "Trasladar" (cambio de ubicación puro, desacoplado del billing). GET animals:read ·
// POST animals:write.
export default function AnimalLocationPanel({ animalId }) {
    const { data, isLoading, error } = useFarmMoves(animalId);
    const [moving, setMoving] = useState(false);

    const current = data?.current_farm;
    const items = data?.items || [];

    return (
        <section className="cat-detail__card">
            <div className="cat-detail__section-head">
                <h2 className="cat-detail__section-title">
                    Ubicación
                    {current && <span className="cat-detail__count">{current.name}</span>}
                </h2>
                <Gate domain="animals" action="write">
                    <button type="button" className="cat-detail__edit" onClick={() => setMoving(true)}><IconFarm /><span>Trasladar</span></button>
                </Gate>
            </div>

            {error ? (
                <p className="cat-detail__empty">{error.status === 403 ? 'Sin permiso para ver la ubicación.' : 'No se pudo cargar la ubicación.'}</p>
            ) : isLoading ? (
                <p className="cat-detail__empty">Cargando…</p>
            ) : (
                <>
                    <p className="cat-detail__empty">Finca actual: <strong>{current?.name || 'sin ubicación registrada'}</strong></p>
                    {items.length > 0 && (
                        <table className="cat-table cat-table--compact">
                            <thead>
                                <tr><th>Desde</th><th>Hasta</th><th>Fecha</th></tr>
                            </thead>
                            <tbody>
                                {items.map((m) => (
                                    <tr key={m.id} className="cat-table__row">
                                        <td>{m.from_farm?.name || <span className="cat-table__empty">—</span>}</td>
                                        <td className="cat-table__name">{m.to_farm?.name || <span className="cat-table__empty">—</span>}</td>
                                        <td>{formatDateOnly(m.moved_on)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </>
            )}

            {moving && <TransferFarmForm animalId={animalId} currentFarm={current} onClose={() => setMoving(false)} onSaved={() => setMoving(false)} />}
        </section>
    );
}
